import styles from './Banner.module.scss'

export default function Banner() {
    return(
        <div className={styles.container}>
            <h1>Projeto Inatú Amazônia - Gestão de dados de impacto</h1>
        </div>
    )
}